import GameBackRewards from '~/pages/game/components/BackRewards/reducers'
import GameGreedyPro from '~/pages/game/GreedyProGame/reducers'
import GameGreedyHiya from '~/pages/game/GreedyHiya/reducers'
import GameLuckySlot from '~/pages/game/LuckySlot/reducers'
import GameGreedyBox from '~/pages/game/GreedyBox/reducers'
import GameLuckyBigWheel from '~/pages/game/LuckyBigWheel/reducers'
import GameBigWheel from '~/pages/game/gameRoom/BigWheel/reducers'
import { GameSinbadReducer } from '~/pages/game/Sinbad/reducers'

export default {
  GameGreedyPro,
  GameBackRewards,
  GameGreedyHiya,
  GameLuckySlot,
  GameGreedyBox,
  GameLuckyBigWheel,
  GameBigWheel,
  GameSinbad: GameSinbadReducer,
}
